// extracted by mini-css-extract-plugin
module.exports = {"container":"reviews_container__9HbYz","list":"reviews_list__NIaXk","button":"reviews_button__d_bKO"};